
  import classNames from 'classnames'
  import type { ShapeComponentType } from '../types'

  export const Shadow01:ShapeComponentType = ({ className, ...props }) => {
    return <svg className={classNames('pintxo-shape', className)} {...props} width="128" height="128" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M127.937 106.994C124.331 126.592 87.1478 111.73 57.4576 117.544C21.152 124.667 -2.48736 115.388 0.208906 101.373C4.56683 78.5024 27.2343 91.6703 57.2067 92.7099C111.101 94.5965 129.222 99.9484 127.937 106.994Z" fill="#0C0D0D"/>
</svg>

  }
  
